import { render, staticRenderFns } from "./AutoDelivery.vue?vue&type=template&id=8953d2ac"
import script from "./AutoDelivery.ts?vue&type=script&lang=ts&external"
export * from "./AutoDelivery.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports